<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="teacherSummary && teacher">
			<title-bar title="Docentes" :percentage="teacherSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="teacherSummary.itemName" :percentage="teacherSummary.itemPercentage" percentageTitle="Promedio Docente" :academicLevelTitle="teacher.academicLevelName"/>
			<div class="col full">
				<div class="row between innerRubric">
					<percentages-summary v-for="coachingCategory in teacherSummary.coachingCategories" :key="coachingCategory.id" :coachingCategory="coachingCategory"></percentages-summary>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import mediator from '@/mediator';
export default {
	props: ['teacherPersonUuid'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		teacherSummary () {
			if (this.$store.state.teachers.summary) return this.$store.state.teachers.summary.find((item) => {
				return item.itemId == this.teacherPersonUuid;
			});
			else return this.$store.state.teachers.summary;
		},
		teacher () {
			if (this.$store.state.teachers.progress) return this.$store.state.teachers.progress.find((item) => {
				return item.teacher.teacherPersonUuid == this.teacherPersonUuid;
			}).teacher;
			else return this.$store.state.teachers.progress;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/teachers/Summary.vue